// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1W1lL","image":"Header_image__3-QbN","name":"Header_name__351DH","info":"Header_info__3_F-h","infoRow":"Header_infoRow__3Sr_l"};